import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import AppContext from 'context/Context';
import { flatRoutes } from 'helpers/utils';

const NavbarNavLinks = ({ routes }) => {
 const routs = flatRoutes(routes);
 const {
  config: { navbarCollapsed, showBurgerMenu },
  setConfig
 } = useContext(AppContext);

 const handleClick = () => {
  if (navbarCollapsed) {
   setConfig('navbarCollapsed', !navbarCollapsed);
  }
  if (showBurgerMenu) {
   setConfig('showBurgerMenu', !showBurgerMenu);
  }
 };

 return routs.map((e, i) => (
  <Nav.Link
   key={i}
   as={Link}
   className={classNames('fw-medium py-1', { 'text-500': !e?.active, 'link-600': e?.active })}
   to={e?.to}
   onClick={handleClick}
  >
   {e.name}
  </Nav.Link>
 ));
};

NavbarNavLinks.propTypes = {
 routes: PropTypes.array
};

export default NavbarNavLinks;
